import React, {createContext, useContext, useEffect, useState} from "react";
import {useLocation} from "react-router-dom";
import {MENU_LIST} from "./constants";
import {useLocalStorageNew} from "../hooks/useLocalStorageNew";
import {PublicApiCall} from "../apis/PublicApiCall";

export const YuJaGlobalState = createContext({
    loading: false,
    setLoading: () => {},
    isTokenExpiredModalShowUp: false,
    setIsTokenExpiredModalShowUp: () => {},
    isCookieEnabled: true,
    isOnline: true,
    effectiveType: null,
    missedResponseMap: {},
    setMissedResponseMap: () => {},
    missedReactionMap: {},
    setMissedReactionMap: () => {},
    toastObjArr: [],
    setToastObjArr: () => {},
    selectedIntegrationBtn: "",
    setSelectedIntegrationBtn: () => {},
    isQuickSetupModalDismissed: true,
    setIsQuickSetupModalDismissed: () => {},
    globalHostResource: {},
    setGlobalHostResource: () => {},
});

export function YuJaGlobalStateProvider({ children }) {
    const hostName = window.location.hostname;
    const {resolveShortName} = PublicApiCall();
    const [loading, setLoading] = useState(false);
    const [isOnline, setIsOnline] = useState(navigator.onLine);
    const [effectiveType, setEffectiveType] = useState(null);
    const [missedResponseMap, setMissedResponseMap] = useState({});
    const [missedReactionMap, setMissedReactionMap] = useState({});
    const [isCookieEnabled, setIsCookieEnabled] = useState(window.navigator.cookieEnabled);
    const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
    let location = useLocation();
    // let {width, height} = useWindowDimensions();
    // const [mainContainerDimension, setMainContainerDimension] = useState({width, height});
    // const [mainExisted, setMainExisted] = useState(false);

    const [isTokenExpiredModalShowUp, setIsTokenExpiredModalShowUp] = useState(false);
    const [toastObjArr, setToastObjArr] = useState([]);
    const [selectedIntegrationBtn, setSelectedIntegrationBtn] = useState("");
    const [isQuickSetupModalDismissed, setIsQuickSetupModalDismissed] = useState(true);
    const [globalHostResource, setGlobalHostResource] = useState({});
    const data = {
        loading,
        setLoading,
        isTokenExpiredModalShowUp,
        setIsTokenExpiredModalShowUp,
        isCookieEnabled,
        isOnline,
        effectiveType,
        missedResponseMap,
        setMissedResponseMap,
        missedReactionMap,
        setMissedReactionMap,
        sidebarCollapsed,
        setSidebarCollapsed,
        toastObjArr,
        setToastObjArr,
        selectedIntegrationBtn,
        setSelectedIntegrationBtn,
        isQuickSetupModalDismissed,
        setIsQuickSetupModalDismissed,
        globalHostResource,
        setGlobalHostResource
        // mainContainerDimension
    }

    const updateNetworkStatus = () => {
        setIsOnline(!!window.navigator.onLine);
    }

    const [setHostResource, getHostResource] = useLocalStorageNew(window.location.hostname, {});

    useEffect(() => {
        let hostResource;
        // const {institutionId, bgImgLocation, ssoConfig, platformSetting} = hostResource;
        // if (institutionId && bgImgLocation && ssoConfig && platformSetting) {
        //     return;
        // }

        let shortName = '';
        if (hostName.endsWith(".engage.yuja.com") && hostName.startsWith("www.")) {
            shortName = hostName.indexOf('.') >= 0 ?
                hostName.substring(hostName.indexOf('.') + 1, hostName.indexOf("engage.yuja.com") - 1) :
                hostName;
        } else {
            shortName = hostName.indexOf('.') >= 0 ?
                hostName.substring(0, hostName.indexOf('.')) :
                hostName;
        }

        resolveShortName(shortName).then(res => {
            hostResource = getHostResource();
            hostResource.shortName = res.shortName;
            hostResource.fullName = res.fullName;
            hostResource.institutionId = res.institutionId;
            hostResource.bgImgLocation = res.bgImgLocation;
            hostResource.imageURL = res.imageURL;
            hostResource.logoImageURL = res.logoImageURL;
            hostResource.ssoConfig = res.ssoConfig;
            hostResource.platformSetting = res.platformSetting;
            hostResource.evpVideoApiUrl = res.evpVideoApiUrl;
            hostResource.privateEVPLink = res.privateEVPLink;
            hostResource.yujaAccountId = res.yujaAccountId;
            hostResource.showChromeExtensions = res.showChromeExtensions;
            setHostResource(hostResource);
            setGlobalHostResource(hostResource);
        });

    }, [])

    // function enables accessibility shortcuts by pressing enter
    useEffect(() => {
        const handleKeyPress = (event) => {
            // Only care about Enter or Space
            if (event.key !== 'Enter' && event.key !== ' ') return;

            const active = document.activeElement;
            if (!active) return;

            // 1. Check Native HTML Elements
            const nativeInteractive = ['BUTTON', 'INPUT', 'SELECT', 'TEXTAREA'].includes(active.tagName);

            // 2. Check ARIA Roles (Base UI uses these heavily)
            const ariaRole = active.getAttribute('role');
            const ariaInteractive = ['button', 'checkbox', 'radio', 'switch', 'menuitem'].includes(ariaRole);

            // 3. Check for specific Base UI internal attributes
            const isBaseUI = active.hasAttribute('data-highlighted') || active.hasAttribute('data-state');

            // IF any of these are true, the component already handles the keypress. EXIT.
            if (nativeInteractive
                || ariaInteractive
                || isBaseUI
            ) {
                return;
            }

            // 4. Otherwise, trigger your manual click logic
            if (active.tagName === 'svg') {
                const clickEvent = new MouseEvent('click', {
                    bubbles: true,
                    cancelable: true,
                    view: window,
                });
                active.dispatchEvent(clickEvent);
            } else {
                active.click();
            }


            // if (event.key === 'Enter') {
            //     if ( event.target.tagName === 'BUTTON' ) {
            //         return;
            //     }
            //
            //
            //
            //
            //     if (document.activeElement.tagName === 'svg') {
            //         const clickEvent = new MouseEvent('click', {
            //             bubbles: true,
            //             cancelable: true,
            //             view: window,
            //         });
            //
            //         document.activeElement.dispatchEvent(clickEvent);
            //     } else {
            //         document.activeElement.click();
            //     }
            // }
        };

        document.addEventListener('keyup', handleKeyPress);

        return () => {
            document.removeEventListener('keyup', handleKeyPress);
        };
    }, []);

    useEffect(() => {
        window.addEventListener("load", updateNetworkStatus);
        window.addEventListener("online", updateNetworkStatus);
        window.addEventListener("offline", updateNetworkStatus);

        return () => {
            window.removeEventListener("load", updateNetworkStatus);
            window.removeEventListener("online", updateNetworkStatus);
            window.removeEventListener("offline", updateNetworkStatus);
        };
    }, []);


    useEffect(() => {
        const {connection, mozConnection, webkitConnection} = window.navigator;

        const conn = connection || mozConnection || webkitConnection;

        if (conn) {
            // Initial setup of effectiveType
            setEffectiveType(conn.effectiveType);

            // Add an event listener to update effectiveType when it changes
            const handleConnectionChange = () => {
                setEffectiveType(conn.effectiveType);
            };

            conn.addEventListener('change', handleConnectionChange);

            // Clean up the event listener when the component unmounts
            return () => {
                conn.removeEventListener('change', handleConnectionChange);
            };
        }
    }, []);

    useEffect(() => {
        if (location.pathname !== MENU_LIST.INTEGRATIONS.path) {
            setSelectedIntegrationBtn("");
        }
    }, [location]);


    return (
        <YuJaGlobalState.Provider value={data} >
            {children}
        </YuJaGlobalState.Provider>
    );
}

export function useLoading() {
    const context = useContext(YuJaGlobalState);
    if (!context) {
        throw new Error("useLoading must be used within LoadingProvider");
    }
    return context;
}